import config from './config.json'

import http from './httpService'
import axios from 'axios';

export const getInviteData = () => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`

    return http.get(`${config.coinbaseapi}/referrals`)
}